import React from "react";
// import TableComandas from "../components/TableComandas";
import AppOrdenCobroReactTable from "../table/AppOrdenCobroReactTable";

import Footer from "../components/Footer";

import "../css/footer.css";

const OrdenCobro = () => {
  return (
    <>
      <AppOrdenCobroReactTable />
      {/* <TableComandas /> */}
      <Footer />
    </>
  );
};

export default OrdenCobro;
